export function cleanStorage() {
  localStorage.clear();
}
